import React,{useState,useEffect} from 'react';
import { Dialog,DialogTitle,DialogContent,DialogActions,TextField,Button,Stack } from '@mui/material';
import apiService from '../services/apiService.ts';

interface Props{
  open:boolean;
  onClose:()=>void;
  spaceId:string;
  initial?:any;
  onSaved:()=>void;
}

const TableDialog:React.FC<Props>=({open,onClose,spaceId,initial,onSaved})=>{
  const [name,setName]=useState('');
  const [seats,setSeats]=useState(4);

  useEffect(()=>{
    if(initial){setName(initial.name||'');setSeats(initial.seats||4);}else{setName('');setSeats(4);}  
  },[initial]);

  const handleSave=async()=>{
    const payload={name,seats};
    if(initial?.id) await apiService.updateTable(spaceId,initial.id,payload);
    else await apiService.createTable(spaceId,payload);
    onSaved();
    onClose();
  };

  return(
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initial?'Edit Table':'New Table'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField label="Name" value={name} onChange={e=>setName(e.target.value)} fullWidth />
          <TextField label="Seats" type="number" value={seats} onChange={e=>setSeats(Number(e.target.value))} fullWidth />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};
export default TableDialog;